import Icon from '@/atoms/Icon/Icon';
import colors from '@/theme/constants/colors';
import constantsFactory from '@/utils/constants';
import {StyledRatingContainer} from './styles';
import {Props} from './typings';

const {DATA_TEST_ID} = constantsFactory();

const Rating = ({value, size, className}: Props) => {
  const normalizedValue = Number(value);
  const fullStars = Math.floor(normalizedValue);
  const halfStar = normalizedValue % 1 !== 0;
  const emptyStars = 5 - Math.ceil(normalizedValue);

  return (
    <StyledRatingContainer
      className={className}
      data-testid={DATA_TEST_ID.RATING}
      aria-label={`Rating: ${value} out of 5 stars`}
    >
      {[...Array(fullStars)].map((_, index) => (
        <Icon type="star" fontSize={size} color={colors.red100} key={index} />
      ))}

      {halfStar && <Icon type="star-half" fontSize={size} color={colors.red100} />}

      {[...Array(emptyStars)].map((_, index) => (
        <Icon type="star-outline" fontSize={size} color={colors.red100} key={index} />
      ))}
    </StyledRatingContainer>
  );
};

export default Rating;
